export function values<Value = any>(target: Array<Value>): Generator<Value>;
export function values<Value = any>(target: Record<any, Value>): Generator<Value>;

/**
 * Creates an iterator that iterates through the values of both objects and arrays
 */
export function* values(target: any) {
	if (typeof target !== 'object') return;

	if (Array.isArray(target)) {
		for (let i = 0; i < target.length; ++i) yield target[i];

		return;
	}

	for (const key in target) {
		if (!Object.prototype.hasOwnProperty.call(target, key)) continue;

		yield target[key];
	}
}